import { ApexOptions } from "apexcharts";
import React from "react";
import ReactApexChart from "react-apexcharts";
import { YAxisConfig } from "../../pages/Dashboard/Home.tsx";

interface ChartFiveProps {
  chartData?: {
    series: { name: string; data: number[] }[];
    categories?: string[];
  };
  loading?: boolean;
  xAxisCategories?: string[];
  yAxisConfig?: YAxisConfig | null;
}

const EMPTY_SERIES = [{ name: "Нови договори", data: [] as number[] }];

console.log("Test VC");

const NewContractsChart: React.FC<ChartFiveProps> = ({
  chartData,
  loading = false,
  xAxisCategories = [],
  yAxisConfig,
}) => {
  // Derive series directly from props — no internal state needed.
  // This ensures stale data from a previous session never lingers
  // when chartData is null during a fresh fetch.
  const series =
    chartData && chartData.series.length > 0 ? chartData.series : EMPTY_SERIES;

  const options: ApexOptions = {
    colors: ["#243095"],
    chart: {
      fontFamily: "Satoshi, sans-serif",
      type: "bar",
      height: 350,
      toolbar: { show: false },
      background: "transparent",
      foreColor: "currentColor",
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "50%",
        borderRadius: 4,
      },
    },
    dataLabels: { enabled: false },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories: xAxisCategories,
      axisBorder: { show: false },
      axisTicks: { show: false },
      labels: {
        style: {
          colors: "#475569",
          fontSize: "12px",
          fontFamily: "Satoshi, sans-serif",
        },
      },
    },
    yaxis: {
      min: 0,
      max: yAxisConfig?.max ?? 10000,
      tickAmount: yAxisConfig?.tickAmount ?? 10,
      title: {
        text: "Брой договори",
        style: {
          color: "#475569",
          fontSize: "13px",
          fontFamily: "Satoshi, sans-serif",
          fontWeight: 500,
        },
      },
      labels: {
        style: {
          colors: ["#475569"],
          fontSize: "12px",
          fontFamily: "Satoshi, sans-serif",
        },
      },
    },
    legend: {
      show: true,
      position: "top",
      horizontalAlign: "right",
      fontFamily: "Satoshi, sans-serif",
      labels: { colors: "currentColor" },
      itemMargin: { horizontal: 10, vertical: 5 },
    },
    grid: {
      strokeDashArray: 5,
      borderColor: "#E2E8F0",
      yaxis: { lines: { show: true } },
      xaxis: { lines: { show: false } },
    },
    fill: { opacity: 1 },
    tooltip: {
      theme: "light",
      style: { fontSize: "12px", fontFamily: "Satoshi, sans-serif" },
      y: { formatter: (val) => val.toLocaleString() },
    },
    noData: {
      text: "Няма данни",
      align: "center",
      verticalAlign: "middle",
      style: {
        color: "#64748B",
        fontSize: "14px",
        fontFamily: "Satoshi, sans-serif",
      },
    },
  };

  return (
    <div className="border-stroke shadow-default dark:border-strokedark dark:bg-boxdark col-span-12 rounded-sm border bg-white">
      <div className="border-stroke dark:border-strokedark flex justify-between border-b px-6 py-5">
        <div>
          <h2 className="text-title-md2 mb-1.5 font-bold text-black dark:text-white">
            Нови договори
          </h2>
          <p className="text-bodydark1 text-sm font-medium dark:text-slate-400">
            Исторически данни за последните 12 месеца
          </p>
        </div>
      </div>

      <div className="py-7.5 px-6">
        {loading ? (
          <div className="flex h-80 items-center justify-center">
            <div className="border-primary h-12 w-12 animate-spin rounded-full border-4 border-solid border-t-transparent" />
          </div>
        ) : (
          <div
            id="chartFive"
            className="-ml-5 text-slate-600 dark:text-slate-300"
          >
            <ReactApexChart
              options={options}
              series={series}
              type="bar"
              height={350}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default NewContractsChart;
